import { fillLevelSensorConfigurationGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("fill-level-sensor-preset"),
  endpoint: "fill-level-sensor-configuration-groups",
  operations: fillLevelSensorConfigurationGroupsOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN, ROLE.FILL_SENSOR_VIEW, ROLE.FILL_SENSOR_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN, ROLE.FILL_SENSOR_ADMIN],
  singularName: (t) => t("Fill level sensor preset"),
  name: (t) => t("Fill level sensor presets"),
  syncCustomerFilter: true,
  dependencies: ["container"],
});

export default conf;
